import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
} from "@mui/material";
import {
  fetchOrders,
  fetchPaymentOrders,
} from "../../../redux/actions/DashboardActions";
import PaymentStatusBadge from "./PaymentStatus";

const PaymentOrderTable = () => {
  const [tabValue, setTabValue] = useState("Due");
  const [orderBy, setOrderBy] = useState("date");
  const [order, setOrder] = useState("asc");

  const dispatch = useDispatch();
  const { dealerInfo } = useSelector((state) => state.dealerLogin);
  const { orders, loading } = useSelector((state) => state.payOrders);

  useEffect(() => {
    if (dealerInfo) {
      dispatch(
        fetchPaymentOrders(
          dealerInfo._id,
          tabValue === "Due" ? "false" : "true",
          order,
          orderBy,
          dealerInfo.token
        )
      );
    }
  }, [tabValue, orderBy, order, dealerInfo, dispatch]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  return (
    <div>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Payment Orders Table
      </Typography>
      <Box sx={{ width: "100%" }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="payment status tabs"
        >
          <Tab label="Due Orders" value="Due" />
          <Tab label="Paid Orders" value="Paid" />
        </Tabs>
      </Box>
      {loading ? (
        <h1>Loading....</h1>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "date"}
                    direction={order === "asc" ? "asc" : "desc"}
                    onClick={(e) => handleRequestSort(e, "date")}
                  >
                    Date
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "productType"}
                    direction={order === "asc" ? "asc" : "desc"}
                    onClick={(e) => handleRequestSort(e, "productType")}
                  >
                    Product Type
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "tag"}
                    direction={order === "asc" ? "asc" : "desc"}
                    onClick={(e) => handleRequestSort(e, "tag")}
                  >
                    Tag
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                  >
                    Order Number
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "orderFactor"}
                    direction={order === "asc" ? "asc" : "desc"}
                    onClick={(e) => handleRequestSort(e, "orderFactor")}
                  >
                    SQFT
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "payment"}
                    direction={order === "asc" ? "asc" : "desc"}
                    onClick={(e) => handleRequestSort(e, "payment")}
                  >
                    Payment
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "quantity"}
                    direction={order === "asc" ? "asc" : "desc"}
                    onClick={(e) => handleRequestSort(e, "quantity")}
                  >
                    Quantity
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === "paymentStatus"}
                    direction={order === "asc" ? "asc" : "desc"}
                    onClick={(e) => handleRequestSort(e, "paymentStatus")}
                  >
                    Payment Status
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders.map((order) => (
                <TableRow key={order._id}>
                  <TableCell>
                    {new Date(order.createdAt).toLocaleDateString()}
                  </TableCell>
                  <TableCell>{order.productType}</TableCell>
                  <TableCell>{order.tag}</TableCell>
                  <TableCell>{order?.orderNumber}</TableCell>
                  <TableCell>{order.orderFactor}</TableCell>
                  <TableCell>{order.payment}</TableCell>
                  <TableCell>{order.orderArray.length}</TableCell>
                  <TableCell>
                    {" "}
                    <PaymentStatusBadge paymentStatus={order.paymentStatus} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default PaymentOrderTable;
